// extracted by mini-css-extract-plugin
export default {"navbar-item":"style_navbar-item__Y+fzA","active":"style_active__2XTNf"};